import { serializeParams } from '../core/middleware';
import { createRgAPI } from '../core/rgRequest';

type InstagramAccount = {
  username: string;
  profile_pic: string;
  has_profile_picture: boolean;
  id: string;
  is_private: boolean;
  is_published: boolean;
};

export type InstagramGroup = {
  name: string;
  id: string;
  ig: InstagramAccount[];
};

const instagramAPI = createRgAPI('/instagram').withMiddleware(serializeParams);

export const getBusinessInstagramAccounts = async (): Promise<InstagramGroup[]> => {
  try {
    const { data } = await instagramAPI.appendPath('/business').get();

    return data;
  } catch (e) {
    throw new Error(e);
  }
};

export const getShadowInstagramAccounts = async (pageId: string): Promise<InstagramGroup[]> => {
  try {
    const { data } = await instagramAPI.appendPath('/shadow').get({ pageId });

    return data;
  } catch (e) {
    throw new Error(e);
  }
};

export const getPageInstagramAccounts = async (pageId: string): Promise<InstagramGroup[]> => {
  try {
    const { data } = await instagramAPI.appendPath('/page').get({ pageId });

    return data;
  } catch (e) {
    throw new Error(e);
  }
};
